<template>
	<div>
		<van-overlay :show="resourcesPopShow" @click="closeShow" z-index="5000" :lock-scroll="false">
			<div class="resourcesPop"  @click.stop>
				<div class="resourcesPop-title">请选择您擅长的领域</div>
				<div class="resourcesPop-list flex flex-align-center flex-jus-between flex-wrap">
					<div class="resourcesPop-list-item" :class="{'resourcesPop-list-itemActive': item.id == majorId}" v-for="item in majorList" :key="item.id" @click.stop="changeResourcesPop(item.id, item.name)">{{item.name}}</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
/* eslint-disable */
import {mapState} from 'vuex'
export default {
	props: {
		majorId: {
			type: [String, Number],
			default: ''
		},
		resourcesPopShow: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			show: false
		};
	},
	computed: {
		...mapState(['majorList'])
	},
	created() {},
	mounted() {},
	methods: {
		closeShow() {
			this.$emit('update:resourcesPopShow', false);
		},
		changeResourcesPop(id, name) {
			this.$emit('changeResourcesPop', {id,name});
			// resourcesPopShow = false
		}
	}
};
</script>

<style scoped lang="stylus">
.resourcesPop
	width 652px
	max-height 60vh
	overflow-y auto
	padding 40px 28px
	background-color #FFFFFF
	margin 20vh auto 0 auto
	border-radius 20px
	.resourcesPop-title
		width 100%
		text-align center
		font-size 34px
		font-weight bold
		color #0A0A0A
	.resourcesPop-list
		.resourcesPop-list-item
			margin-top 40px
			padding 18px 26px
			border 2px solid #B1B1B1
			border-radius 38px
			min-width 160px
			height 76px
			font-size 28px
			color #000000
			text-align center
		.resourcesPop-list-itemActive
			border none
			background #DE113C
			color #FFFFFF
</style>
